import {onDocumentReady} from '@/helpers';
import {app} from '@/app';

/**
 * init App on document ready
 */
onDocumentReady(() => {
  app.init();
});

/**
 * Make App accessible globally
 * @type {App}
 */
window[app.configuration.appKey] = app;
